import React from 'react';
import { Footer } from '@exxonmobil/react-unity';

const MainFooter = () => <Footer color="dark" />;

export default MainFooter;
